/* eslint-disable react/prop-types */
import React, { useRef } from 'react'
import { useFormPageHandler } from 'irmlib/hooks'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { TextField } from 'irmlib/components/FormControls'
import PropTypes from 'prop-types'
import { YDivider } from 'irmlib/styles'
import { useTranslation } from 'react-i18next'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import { OutlinedButton, ContainedButton } from 'irmlib/components/Controls'
import { Grid } from '@material-ui/core'
import { errorToast, successToast } from '../../../common/functions'

const SELECT_REQUEST_ID = 0
const SELECT_ORDER_NUMBER = 1

const getService = async (setState) => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

// const initialSate = {}

export const LocalOrderModifyModal = (props) => {
  const { showModal, requestId, handleShowModal } = props
  const [open, setOpen] = React.useState(showModal)
  // const [state, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const refLocalBusyCursor = useRef(null)

  
  // const useStyles = makeStyles((theme) => ({
  //   container: {
  //     padding: theme.spacing(1),
  //     borderRadius: 8,
  //     width: 'fit-content',
  //     margin: '1rem',
  //     border: '1px solid #c9c9c9',
  //     fontSize: '0.875rem',
  //     display: 'flex',
  //     justifyContent: 'space-between'
  //   },
  //   content: {
  //     fontSize: '0.875rem',
  //     lineHeight: 2.5
  //   },
  //   value: {
  //     color: '#58595b'
  //   }
  // }))

  // const classes = useStyles()

  const formTemplate = [
    {
      label: 'demo.requestId',
      fieldKey: 'requestId',
      isRequired: true,
      value: requestId,
      defaultValue: requestId,
    },
    {
      label: 'templates.orderNumberRequired',
      fieldKey: 'orderNumber',
      isRequired: true,
      maxLength: 9,
    }
  ]

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })
  
  const VerticalDivider = () => <YDivider height="20px" />

  const handleClose = () => {
    setOpen(false)
    handleShowModal(false)
  }

  const updateOrderId = async() => {
    const orderId = arrRefs[SELECT_ORDER_NUMBER]?.current?.getValue()
    if (!orderId) {
      errorToast({ message: t('smartCatalog.orderIdRequired'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
    } else {
      await localGdeTransactions.updateRequestData(requestId, {
        orderId: orderId,
        apiResponse: {},
        updatedTS: (new Date()).toISOString(),
      })
      handleClose()
      successToast({ message: t('smartCatalog.updateOrderNoSuccess'), title: t('toast.success'), autoHideDuration: 3000, isBlocking: false })
    }
  }
  
  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth='xs'>
        <DialogTitle>{t('smartCatalog.updateOrderNo')}</DialogTitle>
        <DialogContent>
          <>
            <VerticalDivider />
            {/* <Label style = {{ minWidth: '350px' }}>{t('demo.requestId')} - {requestId}</Label> */}
            <VerticalDivider />
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  id={'createActivity_requestId'}
                  data={data}
                  fieldTemplate={formTemplate[SELECT_REQUEST_ID]}
                  ref={arrRefs[SELECT_REQUEST_ID]}
                  style={{ marginBottom: '20px' }}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={'createActivity_orderNumber'}
                  data={data}
                  inputProps={{ maxLength: formTemplate[SELECT_ORDER_NUMBER].maxLength }}
                  fieldTemplate={formTemplate[SELECT_ORDER_NUMBER]}
                  ref={arrRefs[SELECT_ORDER_NUMBER]}
                  style={{ marginBottom: '20px' }}
                  autoFocus
                />
              </Grid>
            </Grid>
          </>
        </DialogContent>
        <DialogActions sx={{ pb: 2, pr: 2 }}>
          <OutlinedButton
            style={{ width: '90px', height: '36.5px', margin: '5px' }}
            onClick={handleClose}
          >
            buttons.cancel
          </OutlinedButton>
          <ContainedButton
            style={{ width: '80px', height: '36.5px', margin: '5px' }}
            onClick={(e) => updateOrderId(e)}
          >
            buttons.save
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

LocalOrderModifyModal.propTypes = {
  showModal: PropTypes.bool,
  handleShowModal: PropTypes.func,
}